module.exports = __webpack_public_path__ + "img/img8_1.4cebd0bb.svg";